import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "\u6210\u5458\u901A\u77E5"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M13.9176 11.5392C16.4996 12.0682 19.5033 13.7909 19.5033 18.7589C19.5033 20.0837 17.7577 20.0837 12.1042 20.0837C6.3803 20.0837 4.70508 20.0837 4.70508 18.7589C4.70508 13.8576 7.70642 12.0704 10.2907 11.5392C8.26639 10.4789 7.56818 8.02936 8.5452 6.04216C9.52222 4.05496 11.9659 3.32588 13.8497 4.38616C15.7334 5.44645 16.5019 7.89599 15.4546 9.8165C15.1032 10.6123 14.5455 11.1413 13.9176 11.5392Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  d: "M8.07671 11.4589C8.29695 11.3967 8.35318 11.1255 8.17043 10.9921C6.54909 9.81401 6.05239 7.62231 6.94037 5.81516C7.07158 5.54843 7.22856 5.30392 7.40896 5.08386C7.55891 4.90159 7.40428 4.63707 7.16061 4.65708C6.11096 4.74154 5.11988 5.35504 4.6138 6.38421C3.90623 7.82237 4.2811 9.55839 5.53693 10.5275C5.71031 10.6631 5.65877 10.9254 5.44321 10.9899C3.50558 11.5634 1.5 13.0904 1.5 16.6981C1.5 17.2516 1.85847 17.5183 2.84018 17.6494C2.99716 17.6694 3.14242 17.5627 3.15882 17.4116C3.54541 13.695 5.86495 12.0791 8.07671 11.4589V11.4589Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  d: "M15.9231 11.4589C15.7029 11.3967 15.6467 11.1255 15.8294 10.9921C17.4507 9.81401 17.9474 7.62231 17.0595 5.81516C16.9283 5.54843 16.7713 5.30392 16.5909 5.08386C16.4409 4.90159 16.5956 4.63707 16.8392 4.65708C17.8889 4.74154 18.8799 5.35504 19.386 6.38421C20.0936 7.82237 19.7187 9.55839 18.4629 10.5275C18.2895 10.6631 18.3411 10.9254 18.5566 10.9899C20.4943 11.5634 22.4998 13.0904 22.4998 16.6981C22.4998 17.2516 22.1414 17.5183 21.1597 17.6494C21.0027 17.6694 20.8574 17.5627 20.841 17.4116C20.4544 13.695 18.1349 12.0791 15.9231 11.4589V11.4589Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var ____ = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { ____ as default };
